query MobileSdkTestSeverities($runId: ConditionID!) {
	msdk_test_by_severity(run_id_eq: $runId) {
		severity_name
		total_issues
	}
	msdk_scans_impacted_per_issue_severity(run_id_eq: $runId) {
		severity_name
		total_scans
	}
}

